import {ButtonArrowIcon} from "@/app/[locale]/common/assets/ButtonArrowIcon/ButtonArrowIcon";
import {TSliderButtonsGroupProps} from "@/app/[locale]/common/components/SliderButtonsGroup/types";

export const SliderButtonsGroup = ({ navigationId }: TSliderButtonsGroupProps) => {
    return (
        <div className={'industries-slider__navigation-buttons'}>
            <button className={`industries-slider__custom-prev industries-slider__custom-prev-${navigationId}`}><ButtonArrowIcon
                color={'black'}/></button>
            <button className={`industries-slider__custom-next industries-slider__custom-next-${navigationId}`}><ButtonArrowIcon
                color={'black'}/></button>
        </div>
    );
};